import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { useGroups } from 'root/src/client/v2/auth/hooks/useGroups';
export function useIsCreator() {
    const { groups } = useGroups();
    return {
        isCreator: groups.includes(AuthGroup.Creator),
    };
}
